module.exports = __webpack_public_path__ + "static/media/medium.54f8078b.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/medium.woff2
// module id = 47
// module chunks = 0